<footer>
  <p>
    &copy; Copyright
    {{ currentYear }}
    vendor.eshopbox.com Powered by
    <img src="assets/images/footer-logo.jpg" alt="" /> shopbox
  </p>
</footer>
